/* eslint-disable import/prefer-default-export */

const ENV = import.meta.env.MODE;

const ORLOTTIS_ACCOUNT_ID = 532;
export function _IS_ORLETTIS_ACCOUNT(user) {
  return ENV === 'production' && user?.value?.account?.id === ORLOTTIS_ACCOUNT_ID;
}

export function _IS_TEMP_ENVIRONMENT() {
  return !window.Cypress && ENV === 'staging';
}
